// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-devider[data-v-01bbc7e3]{border:.35rem solid #f5f5f5}.border-b[data-v-01bbc7e3]{border-bottom:.5px solid rgba(0,0,0,.12)}.border-t[data-v-01bbc7e3]{border-top:.5px solid rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;
